module.exports = __webpack_public_path__ + "static/widespread-conspiracy-desktop-09299afc9b5ac244f899a879c19b1d44.svg";